module.exports = __webpack_public_path__ + "static/media/donafacil.3bcc4e11.svg";